module.exports = __webpack_public_path__ + "static/img/banner-bg.a3dd12d8.svg";